import { Plan2PlateDrawer, Plan2PlateDrawerHeader } from "./Plan2PlateDrawer";
import React from "react";
import { FoodEditor } from "./FoodEditor";
import Food, { initialFood } from "../data/food";
import { queryKeys } from "../queries/queries";
import { useQueryClient } from "@tanstack/react-query";
import { invalidatePurchases } from "../queries/caches";
import { seedFood } from "../queries/caches";

export function CreateFoodDrawer(props: {
  onClose: () => void;
  open: boolean;
  onSubmit: (createdFood: Food) => void;
}) {
  const queryClient = useQueryClient();
  return (
    <Plan2PlateDrawer
      onClose={props.onClose}
      open={props.open}
      header={<Plan2PlateDrawerHeader heading={"Lebensmittel erstellen"} />}
      body={
        <div className="flex w-full flex-col">
          <FoodEditor
            initialFood={initialFood}
            isCreate
            onClose={props.onClose}
            afterSave={async (createdFood) => {
              seedFood(queryClient, createdFood);
              await invalidatePurchases(queryClient);
              props.onClose();
              props.onSubmit(createdFood);
            }}
            allowUnitDeletion={true}
          />
        </div>
      }
    />
  );
}
